import React, { useState } from "react";
import styled from "styled-components";
import { CSSTransition } from "react-transition-group";
import Button from "../Generic/Button";
import SuccessButton from "../Generic/SuccessButton";
import InputBox from "../Generic/InputBox";
import { errorNotification, successNotification } from "../Generic/Notifications";
import close from "../Assets/Close.png";
import OffersService from "./Services/OffersService";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 2rem;
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
`;

const Div = styled.div`
	color: ${(props) => props.color};
	background: ${(props) => props.background};
	height: ${(props) => props.height};
	width: ${(props) => props.width};
	display: flex;
	gap: ${(props) => props.gap};
	flex-direction: ${(props) => props.flexDirection};
	align-items: ${(props) => props.alignItems};
	justify-content: ${(props) => props.jContent};
	flex-wrap: ${(props) => props.flexWrap};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	box-shadow: ${(props) => props.boxShadow};
	border-radius: ${(props) => props.borderRadius};
	align-self: ${(props) => props.alignSelf};
	border: ${(props) => props.border};
`;

Div.defaultProps = {
	alignItems: "center",
	jContent: "center",
	flexWrap: "",
	width: "100%",
};

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	margin: ${(props) => props.margin};
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 310;
`;

const ConfirmModal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: 22rem;
	border-radius: 10px;
	overflow-x: hidden;
	z-index: 305;
`;

const ApplyOffers = () => {
	const [showCsvModal, toggleCsvModal] = useState(false);

	async function uploadOffersCsvRequest() {
		const csvInput = document.getElementById("offersCsv");
		if (!csvInput?.files?.[0]) {
			errorNotification("Please upload a file first.");
			return;
		}
		const formData = new FormData();
		formData.append("file", csvInput.files[0]);
		const response = await OffersService.uploadOffersCsv(formData);
		const { data, error } = response;
		if (data) {
			successNotification("Offers applied successfully");
			toggleCsvModal(false);
		}
		if (error) {
			errorNotification(error);
		}
	}

	return (
		<Page>
			<Div
				width="100%"
				alignItem="center"
				jContent=""
				flex-wrap="wrap">
				<Header>Offers</Header>
			</Div>
			<Div width={"max-content"} gap="1rem" jContent="" margin="1.5rem 0 0 0">
				<Button active onClick={() => toggleCsvModal(true)}>
					Upload Offers
				</Button>
			</Div>

			<CSSTransition
				in={showCsvModal}
				timeout={1000}
				classNames="module"
				unmountOnExit>
				<Overlay>
					<ConfirmModal>
						<Div
							color="#fff"
							background="rgba(45, 35, 66, 0.8)"
							padding="1rem"
							jContent="space-between">
							<Span fontSize="1.4rem">Upload CSV</Span>
							<img
								style={{
									height: "1.5rem",
									filter:
										"invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									toggleCsvModal(false);
								}}
							/>
						</Div>
						<Div alignItems="" gap="0.3rem" flexDirection="column" padding="1rem 1rem 0 1rem">
							<Span>File</Span>
							<InputBox width="100%" type="file" id="offersCsv" accept=".csv" />
							<Div gap="1rem" jContent="flex-end" padding="1rem">
								<Button onClick={() => toggleCsvModal(false)}>Cancel</Button>
								<SuccessButton onClick={uploadOffersCsvRequest}>
									Confirm
								</SuccessButton>
							</Div>
						</Div>
					</ConfirmModal>
				</Overlay>
			</CSSTransition>
		</Page>
	);
};

export default ApplyOffers;

